var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.recepcao && !_vm.crm && !_vm.consultorio)?_c('sub-menu-call-center',{attrs:{"ativo":"orcamento"}}):_vm._e(),_c('marcacao',{ref:"marc",attrs:{"orcamento":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }